import React, {useCallback, useEffect} from "react";
import {connect} from "react-redux";
import * as AppAction from "store/app/action";
import * as SearchAction from 'store/search/action'
import {observer} from 'mobx-react'
import useMyStores from "hooks/useMyStores.js";
import css from './home.module.scss'
import useFetchDefaultLive from "hooks/useFetchDefaultLive";
import Block1 from "./Block1";
import NavFloor from "./NavFloor";
import Footer from "./Footer";
import LoginFormPanel from "./LoginFormPanel";
import Center from "./Center";
import HomeAdvStore from "./store/HomeAdvStore";
import HomeSelfFloorStore from "./store/HomeSelfFloorStore";
import HomeFloorStore from "./store/HomeFloorStore";
import * as Api from 'api/api'
import HomeGuessYouLikeStore from "./store/HomeGuessYouLikeStore";
import GuessYouLike from "./GuessYouLike";
import LookAroundBlock from "./LookAroundBlock";
import HomeLookAroundStore from "./store/HomeLookAroundStore";
import IfLoading from "components/if-loading/IfLoading";
import HomeLazyLoadStore from "./store/HomeLazyLoadStore";
import {when} from "mobx";
import HomeAdv from "./HomeAdv";
import SelfFloor from "./SelfFloor";
import Floor from "./Floor";
import FloatMenu from "./FloatMenu";
import Service from "../../components/service/Service";
import Live from "../../components/live/live";
import liveStatusEnum from "../../enum/LiveStatusEnum";


const advStore = new HomeAdvStore()
const selfFloorStore = new HomeSelfFloorStore()
const floorStore = new HomeFloorStore()
const guessYouLikeStore = new HomeGuessYouLikeStore();
const lookAroundStore = new HomeLookAroundStore()

const lazyLoadStore = new HomeLazyLoadStore()

when(() => lazyLoadStore.adv1Flag, () => {
    // 首页广告
    Api.advImgList({}).then(list => {
        advStore.setData({list})
    })
})
when(() => lazyLoadStore.selfFloorFlag, () => {
    // 自营楼层
    selfFloorStore.fetchData().then()
})
when(() => lazyLoadStore.floorFlag, () => {
    // 楼层
    floorStore.fetchData().then()
})
when(() => lazyLoadStore.guessYouLikeFlag, () => {
    // 猜你喜欢
    guessYouLikeStore.fetchData().then()
})
when(() => lazyLoadStore.lookAroundFlag, () => {
    // 随便看看
    lookAroundStore.fetchData().then()
})

// 这个是写直播间的时候临时为true
const onlyLive = false

function Home(props) {
    const {app, searchAction} = props;

    const {hasSelf} = app;
    const {user: userStore, login: loginStore, app: appStore, service: serviceStore} = useMyStores();
    const {data: liveInfo} = useFetchDefaultLive()

    const firstFetchData = useCallback(async () => {
        await appStore.fetchData()
    }, []);

    useEffect(() => {
        firstFetchData().then(() => {
            lazyLoadStore.startLoadNext()
        })
    }, []);


    return (
        <div className={css.page}>
            {/* nav 搜索 banner 秒杀 */}
            {
                !onlyLive &&
                <Block1
                    navFloor={<NavFloor/>}
                />
            }

            <Center containerClassName={css.centerContainer}>
                {/* 广告1 */}
                {
                    !onlyLive && lazyLoadStore.adv1Flag &&
                    <IfLoading
                        className={css.adv1Wrapper}
                        loadCondition={advStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <HomeAdv className={css.adv1} adv={advStore.adv1}/>
                    </IfLoading>
                }

                {/* 自营楼层 */}
                {
                    !onlyLive && lazyLoadStore.selfFloorFlag &&
                    <IfLoading
                        className={css.selfFloorWrapper}
                        loadCondition={selfFloorStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <SelfFloor selfFloorStore={selfFloorStore}/>
                    </IfLoading>
                }

                {/*广告2*/}
                {
                    !onlyLive && lazyLoadStore.adv2Flag &&
                    <IfLoading
                        className={css.adv2Wrapper}
                        loadCondition={advStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <HomeAdv className={css.adv2} adv={advStore.adv2}/>
                    </IfLoading>
                }

                {/* 楼层 */}
                {
                    !onlyLive && lazyLoadStore.floorFlag &&
                    <IfLoading
                        className={css.floorListWrapper}
                        loadCondition={floorStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        {
                            floorStore.list.map((item, i) => {
                                return (
                                    <Floor key={i} data={item} className={css.floor}/>
                                )
                            })
                        }
                    </IfLoading>
                }

                {/* 猜你喜欢 */}
                {
                    !onlyLive && lazyLoadStore.guessYouLikeFlag &&
                    <IfLoading
                        className={css.guessYouLikeWrapper}
                        loadCondition={guessYouLikeStore.loading}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <GuessYouLike goodsList={guessYouLikeStore.list}/>
                    </IfLoading>
                }

                {/* 随便看看 */}
                {
                    !onlyLive &&
                    <IfLoading
                        className={css.lookAroundBlockWrapper}
                        loadCondition={lookAroundStore.notFetch}
                        onLoad={() => lazyLoadStore.startLoadNext()}
                    >
                        <LookAroundBlock
                            lookAroundStore={lookAroundStore}
                        />
                    </IfLoading>
                }
            </Center>

            <Footer/>

            {/*直播间*/}
            {
                liveInfo?.live.status === liveStatusEnum.OPEN &&
                <Live
                    containerClassName={css.liveContainer}
                    userStore={userStore}
                    liveInfo={liveInfo}
                />
            }

            {/* 悬浮菜单 */}
            <div className={css.floatMenuContainer}>
                <FloatMenu floorIds={floorStore.floorIds}/>
            </div>

            {/* 客服 */}
            {serviceStore.show && (
                <div className={css.serviceContainer}>
                    <div className={css.main}>
                        <Service/>
                    </div>
                </div>
            )}

            {
                loginStore.show &&
                <LoginFormPanel/>
            }
        </div>
    )
}

export default connect(
    state => {
        const {app} = state;

        return {app};
    },
    f => ({
        appAction: {
            setCategoryType() {
                f(AppAction.setCategoryType(...arguments));
            }
        },
        searchAction: {
            clearSearchState() {
                f(SearchAction.setKeyword(''))
                f(SearchAction.setGoodsList([]))
            }
        }
    })
)(observer(Home));
